import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=9a5190f2&lang=pug"
import script from "./sendEmail.vue?vue&type=script&lang=js"
export * from "./sendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./sendEmail.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports